<template>
    <div class="main">
        <div class="title">{{title}}</div>

<!--        <div>-->
<!--            <template v-if="browserHelper.isWechat">-->

<!--                <wx-open-launch-weapp :username="externalApp.posterWechatApp.appId"-->
<!--                      :path="externalApp.posterWechatApp.path"-->
<!--                      @launch="onLaunchWeApp" @error="onLaunchWeAppError">-->
<!--                    <script type="text/wxtag-template">-->
<!--                        <style>-->
<!--                            .goToButton {-->
<!--                                width: 223px;-->
<!--                                height: 36px;-->
<!--                            }-->
<!--                        </style>-->
<!--                        <button class="button">小程序测试</button>-->
<!--                    </script>-->
<!--                </wx-open-launch-weapp>-->

<!--            </template>-->
<!--            <template v-else>-->
<!--                <button class="button" @click="onClickWeAppLink">小程序测试</button>-->
<!--            </template>-->
<!--        </div>-->

        <div class="help_content">
            <div class="help_item" v-for="(item , index) in helpList" :key="index"
                @click="goLink(item)">
                <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">

                <template v-if="item.type == 'miniprogram'">
                    <template v-if="browserHelper.isWechat">

                        <wx-open-launch-weapp :username="item.appid" :path="item.path"
                              @launch="onLaunchWeApp" @error="onLaunchWeAppError">
                            <script type="text/wxtag-template">
                                <style>
                                    .font_position {
                                        font-size: 14px;
                                        font-weight: 400;
                                        color: #333333;

                                        background: transparent;
                                        padding: 0;
                                        border: none;
                                    }
                                </style>
                                <button class="font_position">{{item.name}}</button>
<!--                                <span class="font_position">{{item.name}}</span>-->
                            </script>
                        </wx-open-launch-weapp>

                    </template>
                    <template v-else>
                        <span class="font_position" @click="onClickWeAppLink">{{item.name}}</span>
                    </template>
                </template>

                <span class="font_position" v-else>{{item.name}}</span>

                <img class="icon_position" style="width:16px;height:16px;" src="icon/userIcon/help_right.png" alt="">
            </div>
        </div>

    </div>
</template>


<script>

import externalApp from '@data/externalApp';

// part
import generalCmpPart from '@/components/part/generalCmpPart';

// api
import consoleApi        from "@/components/platformApi/consoleApi";

// utils
import appHelper        from "@util/appHelper";
import deviceHelper     from "@util/deviceHelper";
import browserHelper    from "@util/browserHelper";

const config = {
    // 就是以前的购买中心
    title : '会员中心'
};


export default {
    name:'purchaseCenter',
    extends : generalCmpPart,

    data(){
        return{
            title : config.title,
            browserHelper : browserHelper,
            externalApp : externalApp,
            helpList:[{
                img: 'icon/userIcon/poster_icon.png',
                name:'海报小工具',
                type : 'redirect',
                href: '/thirdService/purchaseDetail/1'
            }, {
                img: 'icon/userIcon/courseware_icon.png',
                name:'师讯课件网',
                type : 'redirect',
                href: '/recharge/limitOfDownload'
            },
            // {
            //     img: 'icon/userIcon/shixun_vip_icon.png',
            //     name:'师讯会员',
            //     type : 'goToPage',
            //     href: 'vipIndex'
            // },
            {
                img: 'icon/userIcon/shixun_vip_icon.png',
                name:'师讯精品课程会员',
                type : 'redirect',
                href: '/vip/course_vod'
            }, {
                img: 'icon/userIcon/shixun_vip_icon.png',
                name:'师讯资料文库会员',
                type : 'redirect',
                href: '/vip/datum'
            }, {
                img: 'icon/userIcon/shixun_vip_icon.png',
                name:'师讯精美环创会员',
                type : 'redirect',
                href: '/vip/atlas_vip'
            },
            ]
        }
    },
    methods:{
        goLink(item) {
            if (item.type === 'goToPage')
            {
                appHelper.goToPage(item.href);
            }
            else if (item.type === 'redirect')
            {
                appHelper.redirect(item.href);
            }
        },

        onClickWeAppLink() {
            if (deviceHelper.isBrowser && !browserHelper.isWechat)
            {
                appHelper.showHint('只能在微信里面打开小程序');
            }
        },
        onLaunchWeApp(e) {
            consoleApi.log('launch weapp success', e);
        },
        onLaunchWeAppError(e) {
            consoleApi.log('launch weapp fail', e.detail);
        },
    }
}
</script>


<style lang="scss" scoped>
.main{
    //width:90%;
    margin:0 auto;
    background:#fff;
    margin-top: 16px;
    border-radius: 8px;
    padding: 0 16px;
    box-sizing: border-box;
}

.title{
    padding-top: 12px;
    font-size: 18px;

    font-weight: 600;
    color: #000;

}

.help_content{
    width: 100%;
    padding-bottom: 2px;
    .help_item{
        margin: 16px 0;
        width:100%;
        height: 24px;
        line-height: 24px;
        position: relative;
        .font_position{
            font-size: 14px;

            font-weight: 400;
            color: #333333;

        }
        .icon_position{
            position: absolute;
            top: 4px;
            right: 0px;
        }
    }
}

</style>
